import React, { useState, useEffect } from 'react';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';
import OfficeService from '../../../../../Services/OfficeService';
import OfficeHelper from '../../../../../Helpers/ModelHelpers/OfficeHelper';

/**
 * Office group multi-select (CD-5311). The value is a list of office group ids. The options are the groups of the
 * office list (the shared groups and the offices' own groups, which carry the offices' names), or of the given
 * offices only.
 */
const OfficeGroupMultiSelect = ({ selected = [], onChange = (_officeGroupIds) => {}, offices = null }) => {
  const [officeList, setOfficeList] = useState([]);

  useEffect(() => {
    if (offices) {
      return;
    }
    OfficeService.GetOfficesForSelect()
      .then((result) => {
        setOfficeList(result);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('OGMS26');
      });
  }, [offices]);

  const options = OfficeHelper.GetOfficeGroups(offices ?? officeList).map((officeGroup) => ({
    label: officeGroup.name,
    value: officeGroup.officeGroupId,
  }));
  // MultiChoice matches the values strictly, and a selection may hold the ids as strings.
  const selectedTexts = (Array.isArray(selected) ? selected : []).map((officeGroupId) => `${officeGroupId}`);
  const selectedValues = options
    .filter((option) => selectedTexts.includes(`${option.value}`))
    .map((option) => option.value);

  return (
    <div className='w-100'>
      <MultiChoice
        label=''
        className='rmsc'
        options={options}
        selected={selectedValues}
        onChange={onChange}
      />
    </div>
  );
};

export default OfficeGroupMultiSelect;
